import { isAxiosError } from "axios";
import i18n, { t } from "i18next";
import axios from "../lib/axios";
import { AdministratorPanelUser } from "../types";

export const getAdministratorPanelUsers = async (
  companyId?: number,
): Promise<AdministratorPanelUser[]> => {
  try {
    const { data } = await axios.get<AdministratorPanelUser[]>(
      "/api/administration-panel/users",
      {
        headers: {
          "Accept-Language": i18n.language,
        },
        params: {
          companyId,
        },
      },
    );

    return data;
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};

export const sendDisableTwoFactorAuthenticationOnUserAccountRequest = async (
  userId: number,
): Promise<void> => {
  try {
    await axios.patch(
      `/api/users/${userId}/disable-two-factor-authentication`,
      undefined,
      {
        headers: {
          "Accept-Language": i18n.language,
        },
      },
    );
  } catch (error) {
    let message = t("common.unknownErrorOccurred");

    if (isAxiosError(error)) {
      if (error.response) {
        if (error.response.status === 403) {
          message = t("noPermissions");
        } else if (error.response.data) {
          if (
            "errors" in error.response.data &&
            Array.isArray(error.response.data.errors) &&
            error.response.data.errors.length > 0 &&
            typeof error.response.data.errors[0] === "object" &&
            "message" in error.response.data.errors[0]
          ) {
            message = error.response.data.errors[0].message;
          } else if ("message" in error.response.data) {
            message = error.response.data.message;
          }
        }
      } else if (error.request) {
        message = t("common.noResponseFromServer");
      }
    }

    throw new Error(message);
  }
};
